import React from "react";
import style from "./index.module.scss";

interface Props {
    children: React.ReactChild;
}
export default function NavBar({ children }: Props) {
    return (
        <div className={style.root}>
            <div className={style.links}>{children}</div>
        </div>
    );
}
